import CanvasJSReact from '@canvasjs/react-charts';
import moment from 'moment';
import './Chart.css';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export default function ChartHostory_Production({ solorpower, gridpower, enspower, irr, xlabel, chart_style, cod, error }) {

    var xmin = null
    var xmax = null

    const indexlabel = chart_style.indexlabel
    const xformat = chart_style.xformat
    const tooltip_header = chart_style.tooltip_header
    const tooltip_format = chart_style.tooltip_format
    const plot = [
        { color: "#E74C3C", unit: chart_style.grid_unit, name: chart_style.grid_tag, dp: 3 },
        { color: "#2ECC71", unit: chart_style.solar_unit, name: chart_style.solar_tag, dp: 3 },
        { color: "#566573", unit: chart_style.ens_unit, name: chart_style.ens_tag, dp: 3 },
        { color: "#F1C40F", unit: chart_style.irr_unit, name: 'Irradiation', dp: 3 }
    ]
    var cod_strip = []
    if (cod !== null) {
        cod_strip = [
            {
                startValue: new Date(cod.CODIndex_Start),
                endValue: new Date(cod.CODIndex_Stop),
                color: "#d8d8d8"
            }
        ]
    }

    var xoverlap_startxx = 0
    var xdevide = 2
    if (window.screen.width < 576) {
        if (xformat.includes(":mm")) {
            if (solorpower !== undefined) {
                if (solorpower.length !== undefined) {
                    if (solorpower.length > 100) {
                        xoverlap_startxx = 0
                        xdevide = 3
                    } else {
                        xoverlap_startxx = 3
                    }
                } else {
                    xoverlap_startxx = 3
                }
            } else {
                xoverlap_startxx = 3
            }
        } else if (xformat.includes("YYYY")) {
            if (solorpower !== undefined) {
                if (solorpower.length !== undefined) {
                    const syear = Number(moment(new Date(solorpower[0].x)).format("YYYY"))
                    xoverlap_startxx = syear - 1
                }
            }
        }
    }

    const options = {
        height: 560,
        zoomEnabled: true,
        toolTip: {
            shared: true,
            borderColor: 'rgba(204, 204, 220, 0.12)',
            borderThickness: 1,
            cornerRadius: 2,
            contentFormatter: function (e) {
                if (e.entries[0].dataPoint !== undefined) {
                    var elem = '<p style = "font-family: Inter !important;font-size: 12px !important;margin-bottom:0px;color: black !important;">' + tooltip_header + ' : ' + moment(new Date(e.entries[0].dataPoint.x)).add(0, 'days').format(tooltip_format) + '</p>'
                    elem += '<div class="measure-table" style = "font-family: Inter !important;margin-top:0px;">'
                    for (let i = 0; i < e.entries.length; i++) {
                        if (e.entries[i].dataPoint.y !== undefined) {
                            const sname = e.entries[i].dataSeries.name
                            const filtered = plot.filter(item => item.name === sname);
                            if (filtered.length > 0) {
                                var value = ""
                                if (e.entries[i].dataPoint.y !== 0) {
                                    value = e.entries[i].dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: filtered[0].dp, maximumFractionDigits: filtered[0].dp })
                                } else {
                                    value = e.entries[i].dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                                }
                                elem += '<div class="measure-rows font-bold">' +
                                    '<div class="measure-cell" style = "color:' + filtered[0].color + ';font-size: 11px !important;min-width:150px  !important;">' + e.entries[i].dataSeries.name + '</div>' +
                                    '<div class="measure-cell numberright"  style = "padding-right:8px;font-size: 11px !important;color: black !important;">' + value + '</div>' +
                                    '<div class="measure-cell" style = "width:40px;font-size: 11px !important;color: black !important;">' + filtered[0].unit + '</div>' +
                                    '</div>'
                            }
                        }
                    }
                    elem += '</div>'
                    return elem
                }
            }
        },
        responsive: true,
        backgroundColor: "#fff",
        xValueType: 'dateTime',
        animationEnabled: true,
        title: {
            fontSize: 14,
            fontFamily: 'Inter',
            fontWeight: 'normal',
            horizontalAlign: "left"
        },
        legend: {
            fontFamily: 'poppins',
            fontSize: 12,
            fontWeight: 'normal',
            cursor: "pointer",
            fontColor: '#000',
            horizontalAlign: "center", // "center" , "right"
            verticalAlign: "top",  // "top" , "bottom"
        },
        axisX: {
            interval: 1,
            intervalType: chart_style.xinterval,
            labelFormatter: function (e) {
                if (window.screen.width < 576) {
                    const sxs = moment(new Date(e.value)).format(xformat.replaceAll(":mm", "").replaceAll("MMM", "MM"))
                    const nx = Number(sxs - xoverlap_startxx)
                    if (nx >= 1 && nx % xdevide === 0 && xdevide === 2) {
                        return ""
                    } else if (nx >= 1 && nx % xdevide !== 0 && xdevide === 3) {
                        return ""
                    }
                }
                return moment(new Date(e.value)).format(xformat)
            },
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'bold',
            labelFontFamily: 'poppins',
            labelFontSize: 10,
            title: xlabel,
            margin: -5,
            crosshair: {
                enabled: true,
                snapToDataPoint: true,
                color: "orange",
                labelFontColor: "#F8F8F8",
                labelBackgroundColor: "#1A5276",
            },
            stripLines: cod_strip,
            minimum: xmin,
            maximum: xmax,
        },
        axisY: [{
            title: chart_style.axis_y1,
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'normal',
            titleFontColor: '#2C3E50',
            labelFontFamily: "Inter",
            labelFontSize: 10,
            labelFontWeight: 'normal',
            labelFontColor: '#2C3E50',
            gridDashType: "dash",
            gridColor: "#AEB6BF",
            minimum: 0,
        }],
        axisY2: [{
            title: chart_style.axis_y2,
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'normal',
            titleFontColor: '#2C3E50',
            labelFontFamily: "Inter",
            labelFontSize: 10,
            labelFontWeight: 'normal',
            labelFontColor: '#2C3E50',
            gridDashType: "dash",
            gridColor: "rgba(204, 204, 220, 0.12)",
            minimum: 0,
        }],
        data: [
            {
                type: chart_style.solar_type,
                showInLegend: true,
                legendMarkerType: "square",
                name: chart_style.grid_tag,
                color: "#E74C3C",
                markerType: "none",
                axisYIndex: 0,
                dataPoints: gridpower,
                fillOpacity: 1,
                lineThickness: 1,
                indexLabelFontSize: 10,
                indexLabelFontWeight: "bold",
                indexLabelFontFamily: 'poppins',
                indexLabelOrientation: indexlabel,
                indexLabelFormatter:
                    function (e) {
                        if (window.screen.width < 576) {
                            return ""
                        }
                        if (indexlabel !== "-") {
                            if (e.dataPoint.y !== undefined) {
                                if (e.dataPoint.y > 0) {
                                    return e.dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
                                }
                                return e.dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                            }
                        }
                        return null
                    }
            },
            {
                type: chart_style.solar_type,
                showInLegend: true,
                legendMarkerType: "square",
                name: chart_style.solar_tag,
                color: "#2ECC71",
                markerType: "none",
                axisYIndex: 0,
                dataPoints: solorpower,
                fillOpacity: 0.9,
                lineThickness: 1,
                indexLabelFontSize: 10,
                indexLabelFontWeight: "bold",
                indexLabelFontFamily: 'poppins',
                indexLabelOrientation: indexlabel,
                indexLabelFormatter:
                    function (e) {
                        if (window.screen.width < 576) {
                            return ""
                        }
                        if (indexlabel !== "-") {
                            if (e.dataPoint.y !== undefined) {
                                if (e.dataPoint.y > 0) {
                                    return e.dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
                                }
                                return e.dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                            }
                        }
                        return null
                    }
            },
            {
                type: chart_style.solar_type,
                showInLegend: true,
                legendMarkerType: "square",
                name: chart_style.ens_tag,
                color: "#566573",
                markerType: "none",
                axisYIndex: 0,
                dataPoints: enspower,
                fillOpacity: 0.5,
                lineThickness: 1,
                indexLabelFontSize: 10,
                indexLabelFontWeight: "bold",
                indexLabelFontFamily: 'poppins',
                indexLabelOrientation: indexlabel,
                indexLabelFormatter:
                    function (e) {
                        if (window.screen.width < 576) {
                            return ""
                        }
                        if (indexlabel !== "-") {
                            if (e.dataPoint.y !== undefined) {
                                var error_code = ""
                                if (e.dataSeries.name === "Energy not Supply" && error !== null && error !== undefined) {
                                    const index = e.dataSeries.dataPoints.findIndex(item => item.x === e.dataPoint.x);
                                    if (error[index] !== undefined) {
                                        if (error[index]) {
                                            error_code = "\u274C"
                                        }
                                    }
                                }
                                if (e.dataPoint.y > 0) {
                                    return error_code + e.dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
                                }
                                return error_code + e.dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                            }
                        }
                        return null
                    }
            }, {
                type: chart_style.irr_type,
                showInLegend: true,
                name: 'Irradiation',
                axisYType: "secondary",
                color: "#F1C40F",
                markerType: "none",
                axisYIndex: 1,
                dataPoints: irr,
                lineThickness: 2,
            }]
    }

    return (
        <div className="dashboard-chart-wrapper">
            <CanvasJSChart options={options}
            />
        </div>
    );
}
